import { jsx as e } from "react/jsx-runtime";
import t from "lodash.merge";
import { S as a } from "./SingleWaveTable2.js";
function o({
  data: o = [{
    name: "",
    data: [{
      value: 0,
      rendered: "n/a"
    }]
  }],
  options: r = {
    pivots: ["", ""]
  }
}) {
  const n = t({}, r, {
    style: "simple"
  });
  return e(a, {
    data: o,
    options: n
  });
}
export { o as S };